import { NgModule } from '@angular/core';
import { AuthGuard } from './guards/auth.guard';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { CallbackComponent } from './components/callback/callback.component';
import { NavigationComponent } from './components/general/navigation/navigation.component';

const routes: Routes = [
  {
    path: '',
    component: NavigationComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      {
        path: 'dashboard',
        data: {},
        loadChildren: () =>
          import('./components/dashboard/dashboard.module').then(
            (m) => m.DashboardModule,
          ),
      },
      {
        path: 'beneficiary',
        data: {},
        loadChildren: () =>
          import('./components/beneficiary/beneficiary.module').then(
            (m) => m.BeneficiaryModule,
          ),
      },
      {
        path: 'beneficiary-list',
        data: {},
        loadChildren: () =>
          import('./components/claim-request-section/beneficiary/beneficiary.module').then(
            (m) => m.BeneficiaryModule,
          ),
      },
      {
        path: 'register-hospital',
        data: {},
        loadChildren: () =>
          import('./components/register-hospital/register-hospital.module').then(
            (m) => m.RegisterHospitalModule,
          ),
      },
      {
        path: 'claim-request',
        data: {},
        loadChildren: () =>
          import('./components/claim-request-section/claim-request-section.module').then(
            (m) => m.ClaimRequestSectionModule,
          ),
      },
      {
        path: 'payment-claim',
        data: {},
        loadChildren: () =>
          import('./components/payment-claim/payment-claim-routing.module').then(
            (m) => m.PaymentClaimRoutingModule,
          ),
      },
      {
        path: 'hospital',
        data: {},
        loadChildren: () =>
          import('./components/hospital/hospital.module').then(
            (m) => m.HospitalModule,
          ),
      },
      {
        path: 'pharmacy',
        data: {},
        loadChildren: () =>
          import('./components/pharmacy/pharmacy.module').then(
            (m) => m.PharmacyModule,
          ),
      },
      {
        path: 'report',
        data: {},
        loadChildren: () =>
          import('./components/report/report.module').then(
            (m) => m.ReportModule,
          ),
      },
      {
        path: 'user-account',
        data: {},
        loadChildren: () =>
          import('./components/user-account/user-account.module').then(
            (m) => m.UserAccountModule,
          ),
      },
      {
        path: 'setting',
        data: {},
        loadChildren: () =>
          import('./components/setting/setting.module').then(
            (m) => m.SettingModule,
          ),
      },

      {
        path: 'about-us',
        data: {},
        loadChildren: () =>
          import('./components/about-us/about-us.module').then(
            (m) => m.AboutUsModule,
          ),
      },
    ],
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./components/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'auth/callback',
    component: CallbackComponent,
  },
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      canceledNavigationResolution: 'computed',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
